module.exports = __webpack_public_path__ + "static/img/file_svg.e7b51a7b.png";